module.exports = __webpack_public_path__ + "fonts/ralewaysemibolditalic.b29036b.ttf";